/**
 * Product card — quick-add / mini add-to-cart.
 *
 * Wishlist is handled centrally by assets/wishlist.js (delegated), so this file
 * only wires the .pc__quick-add / .pc__add-btn buttons and watches for injected
 * cards (recently viewed, wishlist page).
 */
(function() {
  'use strict';

  function initCard(card) {
    card.querySelectorAll('.pc__quick-add, .pc__add-btn').forEach(function(btn) {
      if (btn.disabled || btn.dataset.qaBound) return;
      btn.dataset.qaBound = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const variantId = this.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        const originalHTML = btn.innerHTML;
        btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> '+ window.CHiATO_STRINGS.adding;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
        .then(function(r) {
          // 422 (sold out / limit) still returns JSON — treat non-2xx as failure.
          return r.json().then(function(data) {
            if (!r.ok) { throw new Error((data && data.description) || 'Add to cart failed'); }
            return data;
          });
        })
        .then(function() {
          btn.innerHTML = '<i class="fa-solid fa-check" aria-hidden="true"></i> '+ window.CHiATO_STRINGS.added;
          document.dispatchEvent(new CustomEvent('cart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function(err) {
          console.error('Cart add error:', err);
          btn.innerHTML = '<i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i> '+ window.CHiATO_STRINGS.unavailable;
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 1800);
        });
      });
    });
  }

  // Init cards present now.
  document.querySelectorAll('.pc').forEach(initCard);

  // Observe future cards (Load more, recently viewed, wishlist page).
  if (window.MutationObserver) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('pc')) initCard(node);
          if (node.querySelectorAll) node.querySelectorAll('.pc').forEach(initCard);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
